import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  FaGem,
  FaArrowRight,
  FaCheckCircle,
  FaHandshake,
  FaLightbulb,
  FaHeart,
  FaAward,
  FaGlobe,
  FaStar,
  FaMedal,
  FaBuilding,
  FaIndustry,
  FaUniversity,
  FaNetworkWired,
  FaCogs,
} from "react-icons/fa";
import {
  TbTarget,
  TbEye,
  TbBrain,
  TbChartArrows,
  TbArrowsJoin,
  TbArrowsSplit,
} from "react-icons/tb";
import { RiRocket2Fill, RiPsychotherapyFill } from "react-icons/ri";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { GiBrain, GiOrganigram } from "react-icons/gi";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import { FaArrowLeft } from "react-icons/fa6";
import LanguageSwitcher from "components/switcher/LanguageSwitcher";

const AboutPage = () => {
  const { t } = useTranslation();

  // const teamMembers = [
  //   {
  //     name: t("about.teamMember1Name"),
  //     role: t("about.teamMember1Role"),
  //     image:
  //       "https://ui-avatars.com/api/?name=Mah+Mehr&background=6366f1&color=fff&size=128&bold=true",
  //   },
  //   {
  //     name: t("about.teamMember2Name"),
  //     role: t("about.teamMember2Role"),
  //     image:
  //       "https://ui-avatars.com/api/?name=Mobin+Ettehad&background=8b5cf6&color=fff&size=128&bold=true",
  //   },
  // ];

  const values = [
    {
      icon: <FaHandshake className="h-5 w-5 md:h-6 md:w-6" />,
      title: t("about.value1"),
      description: t("about.value1Desc"),
      gradient: "from-blue-400 via-blue-500 to-indigo-500",
      bgGradient:
        "from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20",
    },
    {
      icon: <FaLightbulb className="h-5 w-5 md:h-6 md:w-6" />,
      title: t("about.value2"),
      description: t("about.value2Desc"),
      gradient: "from-amber-400 via-yellow-500 to-orange-500",
      bgGradient:
        "from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20",
    },
    {
      icon: <FaHeart className="h-5 w-5 md:h-6 md:w-6" />,
      title: t("about.value3"),
      description: t("about.value3Desc"),
      gradient: "from-purple-400 via-pink-500 to-purple-500",
      bgGradient:
        "from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20",
    },
    {
      icon: <FaAward className="h-5 w-5 md:h-6 md:w-6" />,
      title: t("about.value4"),
      description: t("about.value4Desc"),
      gradient: "from-purple-400 via-purple-500 to-violet-500",
      bgGradient:
        "from-purple-50 to-violet-50 dark:from-purple-900/20 dark:to-violet-900/20",
    },
  ];

  // const stats = [
  //   {
  //     number: t("about.statYearDesignNumber"),
  //     label: t("about.statYearDesign"),
  //     icon: <FaRocket className="h-4 w-4 md:h-5 md:w-5" />,
  //     gradient: "from-blue-500 to-cyan-500",
  //   },
  //   {
  //     number: t("about.statYearDevNumber"),
  //     label: t("about.statYearDev"),
  //     icon: <FaCodeBranch className="h-4 w-4 md:h-5 md:w-5" />,
  //     gradient: "from-amber-500 to-yellow-500",
  //   },
  //   {
  //     number: "P&S",
  //     label: t("about.statMethodology"),
  //     icon: <GiBrain className="h-4 w-4 md:h-5 md:w-5" />,
  //     gradient: "from-lime-500 to-green-500",
  //   },
  //   {
  //     number: "+7",
  //     label: t("about.statApplications"),
  //     icon: <FaIndustry className="h-4 w-4 md:h-5 md:w-5" />,
  //     gradient: "from-indigo-500 to-purple-500",
  //   },
  // ];

  const features = [
    {
      icon: <TbBrain className="h-6 w-6 md:h-7 md:w-7" />,
      title: t("about.feature1"),
      description: t("about.feature1Desc"),
      gradient: "from-blue-500 to-indigo-500",
    },
    {
      icon: <TbChartArrows className="h-6 w-6 md:h-7 md:w-7" />,
      title: t("about.feature2"),
      description: t("about.feature2Desc"),
      gradient: "from-cyan-500 to-teal-500",
    },
    {
      icon: <TbArrowsJoin className="h-6 w-6 md:h-7 md:w-7" />,
      title: t("about.feature3"),
      description: t("about.feature3Desc"),
      gradient: "from-orange-500 to-amber-500",
    },
    {
      icon: <TbArrowsSplit className="h-6 w-6 md:h-7 md:w-7" />,
      title: t("about.feature4"),
      description: t("about.feature4Desc"),
      gradient: "from-purple-500 to-pink-500",
    },
  ];

  const applicationAreas = [
    { icon: <FaIndustry />, label: t("about.area1") },
    { icon: <FaBuilding />, label: t("about.area2") },
    { icon: <FaUniversity />, label: t("about.area3") },
    { icon: <HiOutlineBuildingOffice />, label: t("about.area4") },
    { icon: <FaGlobe />, label: t("about.area5") },
    { icon: <FaNetworkWired />, label: t("about.area6") },
    { icon: <FaCogs />, label: t("about.area7") },
  ];

  return (
    <div className="min-h-screen overflow-x-hidden bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-navy-900 dark:via-navy-800 dark:to-navy-900">
      <FixedPlugin />

      {/* --- Header with Back Button --- */}
      <header className="sticky top-0 z-50 bg-white/80 shadow-sm backdrop-blur-md dark:bg-navy-900/80">
        <div className="container mx-auto flex items-center justify-between px-4 py-3">
          <Link
            to="/"
            className="group flex items-center gap-2 rounded-full bg-brand-50 px-4 py-2 text-sm font-medium text-brand-600 transition-all hover:bg-brand-100 dark:bg-brand-400/30 dark:text-brand-100 dark:hover:bg-brand-500/50"
          >
            <FaArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1 rtl:rotate-180" />
            <span>{t("about.backHome")}</span>
          </Link>
          <div className="flex gap-2">
            <LanguageSwitcher />
            <div className="flex items-center gap-2">
              <span
                dir="ltr"
                className="text-sm font-bold text-gray-700 dark:text-gray-200"
              >
                VITAL+
              </span>
              <FaGem className="h-5 w-5 text-brand-500" />
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-brand-600 via-purple-600 to-pink-600 py-16 dark:from-brand-800 dark:via-purple-800 dark:to-pink-800 md:py-24">
        <div className="absolute inset-0 bg-cover bg-center opacity-10" />
        <div className="from-black/30 via-transparent to-black/50 absolute inset-0 bg-gradient-to-b" />

        <div className="container relative z-10 mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mx-auto max-w-4xl text-center text-white"
          >
            <motion.div
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ delay: 0.3, type: "spring", bounce: 0.5 }}
              className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-2xl bg-white/20 shadow-2xl ring-2 ring-white/30 backdrop-blur-sm md:mb-6 md:h-24 md:w-24 md:rounded-3xl"
            >
              <FaGem className="h-10 w-10 text-white md:h-12 md:w-12" />
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="mb-4 text-3xl font-bold md:text-5xl lg:text-6xl"
            >
              {t("about.title")}
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="mb-4 text-lg font-light text-white/90 md:text-2xl"
            >
              {t("about.subtitle")}
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="mx-auto mb-6 max-w-2xl px-4 text-sm text-white/90 md:mb-8 md:text-lg"
            >
              {t("about.heroSubtitle")}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              className="flex flex-wrap items-center justify-center gap-3 md:gap-4"
            >
              <Link
                to="/company/companies/create"
                className="group inline-flex items-center gap-2 rounded-xl bg-white px-6 py-3 text-brand-600 transition-all hover:scale-105 hover:shadow-2xl hover:shadow-white/30 dark:bg-white/10 dark:text-white dark:backdrop-blur-sm dark:hover:bg-white/20 md:rounded-2xl md:px-8 md:py-4"
              >
                <FaArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-1 md:h-4 md:w-4" />
                <span className="text-sm font-semibold md:text-base">
                  {t("about.cta")}
                </span>
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 rounded-xl border-2 border-white/30 px-6 py-3 text-sm text-white backdrop-blur-sm transition-all hover:bg-white/10 hover:shadow-2xl md:rounded-2xl md:px-8 md:py-4 md:text-base"
              >
                {t("about.contact")}
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      {/* <section className="container mx-auto -mt-8 px-4 md:-mt-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="grid grid-cols-2 gap-3 rounded-2xl bg-white/80 p-4 shadow-2xl backdrop-blur-lg dark:bg-navy-800/80 md:gap-6 md:rounded-3xl md:p-8 lg:grid-cols-4"
        >
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1, type: "spring" }}
              viewport={{ once: true }}
              className="group flex flex-col items-center justify-center border-b border-gray-200/50 py-3 last:border-0 dark:border-navy-700/50 md:border-b-0 md:border-r md:py-4 lg:last:border-0"
            >
              <div
                className={`mb-2 rounded-xl bg-gradient-to-br md:mb-3 md:rounded-2xl ${stat.gradient} p-2 text-white shadow-lg transition-all group-hover:scale-110 group-hover:shadow-xl md:p-3`}
              >
                {stat.icon}
              </div>
              <div className="text-xl font-bold text-gray-900 dark:text-white md:text-3xl">
                {stat.number}
              </div>
              <div className="text-xs font-medium text-gray-600 dark:text-gray-400 md:text-sm">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section> */}

      {/* Our Story */}
      <section className="container mx-auto px-4 py-12 md:py-16">
        <div className="grid items-center gap-8 md:grid-cols-2 md:gap-16">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-brand-500 px-3 py-1 dark:bg-brand-800 md:mb-3 md:px-6 md:py-1.5">
              <FaStar className="h-3 w-3 text-white md:h-4 md:w-4" />
              <span className="text-[10px] font-medium text-white md:text-xs">
                {t("about.storyBadge")}
              </span>
            </div>
            <h2 className="mb-3 text-2xl font-bold text-gray-900 dark:text-white md:mb-4 md:text-4xl">
              {t("about.storyTitle")}
            </h2>
            <p className="mb-3 text-sm leading-relaxed text-gray-700 dark:text-gray-300 md:mb-4 md:text-lg">
              {t("about.story1")}
            </p>
            <p className="mb-3 text-sm leading-relaxed text-gray-700 dark:text-gray-300 md:mb-8 md:text-lg">
              {t("about.story2")}
            </p>
            <div className="flex flex-wrap gap-2 md:gap-4">
              {[
                {
                  icon: (
                    <FaCheckCircle className="text-emerald-500 h-4 w-4 md:h-5 md:w-5" />
                  ),
                  text: t("about.check1"),
                },
                {
                  icon: (
                    <FaCheckCircle className="h-4 w-4 text-blue-500 md:h-5 md:w-5" />
                  ),
                  text: t("about.check2"),
                },
                {
                  icon: (
                    <FaCheckCircle className="h-4 w-4 text-purple-500 md:h-5 md:w-5" />
                  ),
                  text: t("about.check3"),
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-1.5 rounded-lg bg-gray-50 px-3 py-1.5 dark:bg-navy-800/60 md:gap-2 md:rounded-xl md:px-4 md:py-2"
                >
                  {item.icon}
                  <span className="text-xs font-medium text-gray-700 dark:text-gray-300 md:text-sm">
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative rounded-2xl bg-gradient-to-br from-brand-400 via-purple-500 to-pink-500 p-2 shadow-2xl md:rounded-3xl">
              <div className="rounded-xl bg-white/10 p-4 backdrop-blur-sm dark:bg-navy-800/30 md:rounded-2xl md:p-8">
                <div className="space-y-3 md:space-y-4">
                  {[
                    {
                      icon: <TbTarget className="h-6 w-6 md:h-7 md:w-7" />,
                      text: t("about.missionCard1"),
                      color: "from-blue-500 to-cyan-500",
                    },
                    {
                      icon: <TbEye className="h-6 w-6 md:h-7 md:w-7" />,
                      text: t("about.missionCard2"),
                      color: "from-purple-500 to-pink-500",
                    },
                    {
                      icon: (
                        <RiPsychotherapyFill className="h-6 w-6 md:h-7 md:w-7" />
                      ),
                      text: t("about.missionCard3"),
                      color: "from-emerald-500 to-teal-500",
                    },
                  ].map((item, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.15, type: "spring" }}
                      viewport={{ once: true }}
                      className="group flex items-center gap-3 rounded-xl bg-white/90 p-3 shadow-lg transition-all hover:-translate-y-1 hover:shadow-xl dark:bg-navy-800/90 md:gap-4 md:rounded-2xl md:p-5"
                    >
                      <div
                        className={`flex-shrink-0 rounded-xl bg-gradient-to-br md:rounded-2xl ${item.color} p-2 text-white shadow-lg transition-all group-hover:scale-110 md:p-3`}
                      >
                        {item.icon}
                      </div>
                      <p className="text-xs font-medium text-gray-800 dark:text-gray-200 md:text-sm">
                        {item.text}
                      </p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>

            <motion.div
              animate={{ y: [0, -15, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
              className="absolute -left-2 -top-2 h-12 w-12 rounded-full bg-yellow-400 opacity-30 blur-2xl md:-left-4 md:-top-4 md:h-20 md:w-20"
            />
            <motion.div
              animate={{ y: [0, 15, 0] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
              className="absolute -bottom-2 -right-2 h-16 w-16 rounded-full bg-purple-400 opacity-30 blur-2xl md:-bottom-4 md:-right-4 md:h-24 md:w-24"
            />
          </motion.div>
        </div>
      </section>

      {/* Mission & Vision (Scientific Foundation) */}
      <section className="container mx-auto px-4 pb-6 md:pb-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mb-10 text-center md:mb-16"
        >
          <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-brand-500 px-3 py-1 dark:bg-brand-800 md:mb-3 md:px-4 md:py-1.5">
            <GiBrain className="100 h-3 w-3 text-white md:h-4 md:w-4" />
            <span className="text-[10px] font-medium text-white md:text-xs">
              {t("about.scienceBadge")}
            </span>
          </div>
          <h2 className="mb-3 text-2xl font-bold text-gray-900 dark:text-white md:mb-4 md:text-4xl">
            {t("about.scienceBoxTitle")}
          </h2>
          <p className="mx-auto max-w-3xl px-4 text-sm text-gray-700 dark:text-gray-300 md:text-lg">
            {t("about.scienceBoxDesc1")}
          </p>
          <p className="mx-auto max-w-3xl px-4 text-sm text-gray-700 dark:text-gray-300 md:text-lg">
            {t("about.scienceBoxDesc2")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
          {[
            {
              icon: <TbChartArrows className="h-8 w-8 md:h-10 md:w-10" />,
              title: t("about.science1Title"),
              description: t("about.science1Desc"),
              gradient: "from-blue-500 to-cyan-500",
            },
            {
              icon: <GiOrganigram className="h-8 w-8 md:h-10 md:w-10" />,
              title: t("about.science2Title"),
              description: t("about.science2Desc"),
              gradient: "from-purple-500 to-pink-500",
            },
            {
              icon: <TbArrowsJoin className="h-8 w-8 md:h-10 md:w-10" />,
              title: t("about.science3Title"),
              description: t("about.science3Desc"),
              gradient: "from-indigo-500 to-teal-500",
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.12, type: "spring" }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-2xl bg-white p-6 text-center shadow-lg transition-all hover:-translate-y-3 hover:shadow-2xl dark:bg-navy-800 md:rounded-3xl md:p-8"
            >
              <div
                className={`absolute inset-0 bg-gradient-to-br ${item.gradient} opacity-0 transition-opacity duration-500 group-hover:opacity-5`}
              />
              <div className="relative">
                <div
                  className={`mx-auto mb-4 inline-flex rounded-2xl bg-gradient-to-br md:mb-6 ${item.gradient} p-3 text-white shadow-lg transition-all group-hover:scale-110 group-hover:shadow-xl md:p-4`}
                >
                  {item.icon}
                </div>
                <h3 className="mb-2 text-lg font-bold text-gray-900 dark:text-white md:mb-3 md:text-xl">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-300 md:text-base">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Application Areas */}
      <section className="bg-gradient-to-b from-blue-50 to-indigo-50 py-12 dark:from-navy-900 dark:to-navy-900/50 md:py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mb-10 text-center"
          >
            <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-brand-500 px-3 py-1 dark:bg-brand-800 md:mb-3 md:px-4 md:py-1.5">
              <FaBuilding className="100 h-3 w-3 text-white md:h-4 md:w-4" />
              <span className="text-[10px] font-medium text-white md:text-xs">
                {t("about.areasBadge")}
              </span>
            </div>

            <h2 className="mb-3 text-2xl font-bold text-gray-900 dark:text-white md:mb-4 md:text-4xl">
              {t("about.areasBadge")}
            </h2>
            <p className="mx-auto max-w-2xl px-4 text-sm text-gray-700 dark:text-gray-300 md:text-lg">
              {t("about.areasDesc")}
            </p>
          </motion.div>

          <div className="mx-auto flex flex-wrap items-center justify-center gap-3 md:gap-4 lg:w-2/3">
            {applicationAreas.map((area, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.05, type: "spring" }}
                viewport={{ once: true }}
                className="flex items-center gap-2 rounded-xl bg-white/80 px-4 py-2 shadow-lg backdrop-blur-sm transition-all hover:-translate-y-1 hover:shadow-xl dark:bg-navy-800/80 dark:text-white md:rounded-2xl md:px-6 md:py-3"
              >
                <span className="text-brand-500 dark:text-brand-400">
                  {area.icon}
                </span>
                <span className="text-xs font-medium text-gray-700 dark:text-gray-300 md:text-sm">
                  {area.label}
                </span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission, Vision & Values - Combined Section */}
      <section className="bg-gradient-to-br from-blue-50 via-white to-purple-50 py-12 dark:from-navy-900 dark:via-navy-800 dark:to-navy-900 md:py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mb-10 text-center md:mb-16"
          >
            <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-brand-500 px-3 py-1 dark:bg-brand-800 md:mb-3 md:px-4 md:py-1.5">
              <FaMedal className="h-3 w-3 text-white md:h-4 md:w-4" />
              <span className="text-[10px] font-medium text-white md:text-xs">
                {t("about.mission")}
              </span>
            </div>
            <h2 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white md:mb-3 md:text-4xl">
              {t("about.valuesTitle")}
            </h2>
          </motion.div>

          {/* Mission & Vision Cards */}
          <div className="mb-12 grid gap-6 md:grid-cols-2 md:gap-8">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-2xl bg-white p-6 shadow-lg transition-all hover:-translate-y-2 hover:shadow-2xl dark:bg-navy-800 md:rounded-3xl md:p-8"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-indigo-500 opacity-0 transition-opacity duration-500 group-hover:opacity-5" />
              <div className="relative">
                <div className="mb-4 inline-flex rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-500 p-3 text-white shadow-lg transition-all group-hover:scale-110 group-hover:shadow-xl">
                  <TbTarget className="h-7 w-7 md:h-8 md:w-8" />
                </div>
                <h3 className="mb-3 text-xl font-bold text-gray-900 dark:text-white md:text-2xl">
                  {t("about.ourTitle1")}
                </h3>
                <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 md:text-base">
                  {t("about.ourDesc1")}
                </p>
                <div className="mt-4 h-1 w-12 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 transition-all group-hover:w-full" />
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-2xl bg-white p-6 shadow-lg transition-all hover:-translate-y-2 hover:shadow-2xl dark:bg-navy-800 md:rounded-3xl md:p-8"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500 to-pink-500 opacity-0 transition-opacity duration-500 group-hover:opacity-5" />
              <div className="relative">
                <div className="mb-4 inline-flex rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 p-3 text-white shadow-lg transition-all group-hover:scale-110 group-hover:shadow-xl">
                  <TbEye className="h-7 w-7 md:h-8 md:w-8" />
                </div>
                <h3 className="mb-3 text-xl font-bold text-gray-900 dark:text-white md:text-2xl">
                  {t("about.ourTitle2")}
                </h3>
                <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 md:text-base">
                  {t("about.ourDesc2")}
                </p>
                <div className="mt-4 h-1 w-12 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 transition-all group-hover:w-full" />
              </div>
            </motion.div>
          </div>

          {/* Values Grid */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-8 lg:grid-cols-4">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.12, type: "spring" }}
                viewport={{ once: true }}
                className={`group relative overflow-hidden rounded-2xl bg-gradient-to-br md:rounded-3xl ${value.bgGradient} p-6 shadow-lg transition-all hover:-translate-y-3 hover:shadow-2xl dark:bg-navy-800 dark:shadow-xl md:p-8`}
              >
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${value.gradient} opacity-0 transition-opacity duration-500 group-hover:opacity-5`}
                />
                <div className="relative">
                  <div
                    className={`mb-3 inline-flex rounded-xl bg-gradient-to-br md:mb-5 md:rounded-2xl ${value.gradient} p-2.5 text-white shadow-lg transition-all group-hover:scale-110 group-hover:shadow-xl md:p-3.5`}
                  >
                    {value.icon}
                  </div>
                  <h3 className="mb-2 text-lg font-bold text-gray-900 dark:text-white md:mb-3 md:text-xl">
                    {value.title}
                  </h3>
                  <p className="text-sm text-gray-700 dark:text-gray-300 md:text-base">
                    {value.description}
                  </p>
                  <div
                    className={`mt-3 h-1 w-10 rounded-full bg-gradient-to-r md:mt-4 md:w-12 ${value.gradient} transition-all group-hover:w-full`}
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="container mx-auto px-4 py-12 md:py-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mb-10 text-center md:mb-16"
        >
          <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-brand-500 px-3 py-1 dark:bg-brand-800 md:mb-3 md:px-4 md:py-1.5">
            <RiRocket2Fill className="100 h-3 w-3 text-white md:h-4 md:w-4" />
            <span className="text-[10px] font-medium text-white md:text-xs">
              {t("about.featuresBadge")}
            </span>
          </div>
          <h2 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white md:mb-3 md:text-4xl">
            {t("about.featuresTitle")}
          </h2>
          <p className="mx-auto max-w-2xl px-4 text-sm text-gray-600 dark:text-gray-300 md:text-lg">
            {t("about.featuresDesc")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-8 lg:grid-cols-4">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.12, type: "spring" }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-2xl bg-brand-100/10 p-6 shadow-xl transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl dark:bg-navy-800"
            >
              <div
                className={`absolute inset-0 bg-gradient-to-br ${feature.gradient} opacity-0 transition-opacity duration-300 group-hover:opacity-5`}
              />
              <div
                className={`absolute -right-10 -top-10 h-32 w-32 rounded-full bg-gradient-to-br ${feature.gradient} opacity-0 blur-2xl transition-opacity duration-500 group-hover:opacity-20`}
              />

              <div className="relative">
                <div className="relative mb-4 inline-flex">
                  <div
                    className={`absolute inset-0 rounded-xl bg-gradient-to-br ${feature.gradient} opacity-20 blur-md transition-opacity duration-300 group-hover:opacity-40`}
                  />
                  <div
                    className={`relative inline-flex rounded-xl bg-gradient-to-br ${feature.gradient} p-3 text-white shadow-lg transition-all duration-300 group-hover:scale-110 group-hover:shadow-xl`}
                  >
                    {feature.icon}
                  </div>
                </div>

                <h3 className="mb-2 text-base font-bold text-gray-900 transition-colors duration-300 group-hover:text-brand-600 dark:text-white dark:group-hover:text-brand-200">
                  {feature.title}
                  <span
                    className={`mt-2 block h-0.5 w-0 rounded-full bg-gradient-to-r ${feature.gradient} transition-all duration-300 group-hover:w-full`}
                  />
                </h3>

                <p className="text-sm leading-relaxed text-gray-700 transition-colors duration-300 group-hover:text-gray-700 dark:text-gray-400 dark:group-hover:text-gray-300">
                  {feature.description}
                </p>
              </div>

              <div
                className={`absolute bottom-0 left-0 h-1 w-0 rounded-b-2xl bg-gradient-to-r ${feature.gradient} transition-all duration-500 group-hover:w-full`}
              />
            </motion.div>
          ))}
        </div>
      </section>

      {/* Team Section */}
      {/* <section className="bg-gradient-to-br from-blue-50 via-white to-purple-50 py-12 dark:from-navy-900 dark:via-navy-800 dark:to-navy-900 md:py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mb-10 text-center md:mb-16"
          >
            <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-brand-500 px-3 py-1 dark:bg-brand-800 md:mb-3 md:px-4 md:py-1.5">
              <RiTeamFill className="100 h-3 w-3 text-white md:h-4 md:w-4" />
              <span className="text-[10px] font-medium text-white md:text-xs">
                {t("about.teamBadge")}
              </span>
            </div>
            <h2 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white md:mb-3 md:text-4xl">
              {t("about.teamTitle")}
            </h2>
            <p className="mx-auto max-w-2xl px-4 text-sm text-gray-700 dark:text-gray-300 md:text-lg">
              {t("about.teamDesc")}
            </p>
          </motion.div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
            {teamMembers.map((member, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.12, type: "spring" }}
                viewport={{ once: true }}
                className="group relative w-full overflow-hidden rounded-2xl bg-white p-6 text-center shadow-lg transition-all hover:-translate-y-3 hover:shadow-2xl dark:bg-navy-800 md:w-[calc(50%-1rem)] md:rounded-3xl md:p-8 lg:w-[calc(33.333%-1.5rem)]"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-brand-500 to-purple-500 opacity-0 transition-opacity duration-500 group-hover:opacity-5" />
                <div className="relative">
                  <div className="relative mx-auto mb-4 h-20 w-20 overflow-hidden rounded-full ring-4 ring-brand-100 transition-all group-hover:ring-brand-500 dark:ring-brand-900/30 md:mb-5 md:h-28 md:w-28">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                    />
                  </div>
                  <h3 className="mb-1 text-lg font-bold text-gray-900 dark:text-white md:text-xl">
                    {member.name}
                  </h3>
                  <p className="text-xs font-medium text-brand-600 dark:text-brand-200 md:text-sm">
                    {member.role}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="container mx-auto px-4 py-12 md:py-16">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-brand-500 to-purple-600 p-8 text-center text-white dark:from-brand-700 dark:to-purple-800"
        >
          <div className="absolute left-0 top-0 h-full w-full opacity-10">
            <div className="absolute -left-16 -top-16 h-48 w-48 rounded-full bg-white" />
            <div className="absolute -bottom-16 -right-16 h-48 w-48 rounded-full bg-white" />
          </div>
          <div className="relative z-10">
            <h2 className="mb-3 text-2xl font-bold">{t("about.ctaTitle")}</h2>
            <p className="mx-auto mb-6 max-w-2xl text-sm text-white/90">
              {t("about.ctaDesc")}
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
              <Link
                to="/company/companies/create"
                className="group inline-flex items-center gap-2 rounded-lg bg-white px-6 py-2.5 text-sm text-brand-600 transition-all hover:scale-105 hover:shadow-xl"
              >
                <span className="text-sm font-semibold">
                  {t("home.ctaButton")}
                </span>
                <FaArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 rounded-lg border-2 border-white/30 px-6 py-2.5 text-sm text-white backdrop-blur-sm transition-all hover:bg-white/10 hover:shadow-xl"
              >
                {t("about.contact")}
              </Link>
            </div>
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default AboutPage;
